// Sizing for the lazy-loaded report chart bodies. Lives in its own
// recharts-free module: the section components import these to render
// matching placeholders, and a value import from the chart files themselves
// would pull recharts back into the section chunk and defeat the code split.
export const RADAR_CHART_CONTAINER_CLASS =
  'mx-auto aspect-square h-[320px] w-full md:h-[440px] md:max-h-[440px]'

export const SCATTER_CHART_CONTAINER_CLASS =
  'mx-auto aspect-auto h-[400px] w-full md:h-[430px]'
